import DOMPurify from "dompurify"

/** Strips script/event-handler/etc. XSS vectors from CMS-authored rich text before it's used with v-html */
export default function sanitizeHtml(html?: string | null) {
    if (!html) {
        return ""
    }

    return DOMPurify.sanitize(html)
}
